import Rotas from "./Routes";
import "./App.css";

function App() {
  return <Rotas />;
}

export default App;